export default {
	Service: 'notificationService',
	Status: 'notificationStatus',
};
